// removed by extract-text-webpack-plugin
module.exports = {"aboutContainer":"src-pageComponents-about----about-module---aboutContainer---16hO_","content":"src-pageComponents-about----about-module---content---8t7b9","detailsContainer":"src-pageComponents-about----about-module---detailsContainer---3XlUL","profilePic":"src-pageComponents-about----about-module---profilePic---2yU3t","altProfile":"src-pageComponents-about----about-module---altProfile---3vEiz","aboutFace":"src-pageComponents-about----about-module---aboutFace---3jMjd"};


//////////////////
// WEBPACK FOOTER
// ./src/pageComponents/about/about.module.css
// module id = 409
// module chunks = 144251824217401